// import { React } from 'react';
// import vid1 from '../Assets/hhg_viedos/ft  wide 1.mp4';
// import vid2 from '../Assets/hhg_viedos/hipl05.46.mp4';
// import vid3 from '../Assets/hhg_viedos/hyd  wide 1.mp4';
// import vid4 from '../Assets/hhg_viedos/pick and place  wide 1.mp4';
// import vid5 from '../Assets/hhg_viedos/conveyor  wide 1.mp4';
// import vid6 from '../Assets/hhg_viedos/pick wide 1.mp4';
// import img1 from '../Assets/Images/Innovation.png';
// import img3 from '../Assets/Images/Robotic.png';
// import img2 from '../Assets/Images/Smart.png';
// import img4 from '../Assets/img/case71.png';
// import { ProductsComponent } from './ProductsComponent';
// import heroImage from '../Assets/Images/image 3234.png';

// const Products = () => {
//     return (
//         <>

//                 <div className='page-template page-template-elementor_header_footer page page-id-1458 jkit-color-scheme elementor-default elementor-template-full-width elementor-kit-3 elementor-page elementor-page-1458'>
//             <div id="page" className="jkit-template site">
//                 <div data-elementor-type="wp-page" data-elementor-id="1458" className="elementor elementor-1458">
//                     <div className="elementor-element elementor-element-0ad9abe e-flex e-con-boxed e-con e-parent" data-id="0ad9abe" data-element_type="container" data-settings='{"background_background":"gradient","content_width":"boxed"}' data-core-v316-plus="true" style={{minHeight:'500px', height:'auto', paddingTop:'40px', paddingBottom:'40px'}}
// style={{height:'700px'}}>
//                         <div className="e-con-inner flex flex-row items-center">
//                             <div className="elementor-element elementor-element-77a7fed e-con-full e-flex e-con e-child w-1/2" style={{}} data-id="77a7fed" data-element_type="container" data-settings='{"content_width":"full"}'>
//                                 <div className="elementor-element elementor-element-74dcfa1 elementor-widget__width-inherit elementor-invisible elementor-widget elementor-widget-heading" data-id="74dcfa1" data-element_type="widget" data-settings='{"_animation":"fadeInUp"}' data-widget_type="heading.default">
//                                     <div className="elementor-widget-container">
//                                         <h5 className="elementor-heading-title elementor-size-default text-left" style={{fontSize:'24px'}}>Our Products</h5>
//                                     </div>
//                                 </div>
                                
//                                 <div className="elementor-element elementor-element-2b47805 elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-invisible elementor-widget elementor-widget-jkit_animated_text" data-id="2b47805" data-element_type="widget" data-settings='{"_animation_delay":200,"_animation":"fadeInUp"}' data-widget_type="jkit_animated_text.default">
//                                     <div className="elementor-widget-container">
//                                         <div className="jeg-elementor-kit jkit-animated-text jeg_module_1458_2_676b7a305aa37" data-style="highlighted" data-text="Touch " data-shape="underline">
//                                             <h1 className="animated-text text-left" style={{marginLeft:'-35px'}}>
//                                                 <span className="normal-text style-color" style={{fontSize:'48px', color:'#004E98'}}>Which System Is Right  </span>
//                                                 <span className="normal-text style-color"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none"><path className="style-color" d="M3,77.5s200.54-11,493,0" transform="translate(-2.75 -68.11)"/></svg>
//                                                 </span>
//                                                 <span className="dynamic-wrapper style-color"><span className="dynamic-text" style={{fontSize:'48px', marginBottom:'-20px', color:'#004E98'}}> </span></span>
//                                                 <span className="normal-text style-color" style={{fontSize:'48px', color:'#004E98'}}> For You?</span>
//                                             </h1>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="w-2/6" style={{}}>
// <img 
//   src={heroImage} 
//   alt="Hero Image" 
//   className="w-full h-auto" 
//   style={{width:'100%', height:'auto', display:'block'}}
// />                            </div>
//                         </div>
//                     </div>

//                     <ProductsComponent/>

//                     <div className="elementor-element elementor-element-aceda80 e-flex e-con-boxed e-con e-parent" data-id="aceda80" data-element_type="container" data-settings='{"content_width":"boxed"}' data-core-v316-plus="true" style={{backgroundColor: '#ffffff'}}>
//                         <div className="e-con-inner">
//                             <div className="elementor-element elementor-element-69de9a7 e-flex e-con-boxed e-con e-child" data-id="69de9a7" data-element_type="container" data-settings='{"background_background":"classic","content_width":"boxed"}' style={{backgroundColor: '#F0F6FF'}}>
//                                 <div className="e-con-inner">
//                                     <div className="elementor-element elementor-element-3fd95bf e-flex e-con-boxed e-con e-child" data-id="3fd95bf" data-element_type="container" data-settings='{"content_width":"boxed"}' style={{backgroundColor: '#F0F6FF'}}>
//                                         <div className="e-con-inner">
//                                             <div className="elementor-element elementor-element-4c24650 e-con-full e-flex e-con e-child" data-id="4c24650" data-element_type="container" data-settings='{"content_width":"full"}'>
//                                                 <div className="elementor-element elementor-element-e890865 elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="e890865" data-element_type="widget" data-widget_type="heading.default">
//                                                     <div className="text-container">
//                                                        <h1>
//                                     Auto<span className="highlight-1">TestIQ </span> 
//                                 </h1>
//                                                     </div>
//                                                 </div>
//                                                 <div className="elementor-element elementor-element-5c004df elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="5c004df" data-element_type="widget" data-widget_type="text-editor.default">
//                                                     <div className="elementor-widget-container">
//                                                         <p style={{ fontSize: '18px', textAlign: 'justify', color:'#666' }}>Measure and check the functionality of automotive electronic control units, mechanical parts and related systems.</p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div className="elementor-element elementor-element-47da202 e-con-full e-flex e-con e-child" data-id="47da202" data-element_type="container" data-settings='{"background_background":"classic","content_width":"full"}'>
//                                                 <video 
//                                                     className="custom-video" 
//                                                     autoPlay 
//                                                     muted 
//                                                     loop 
//                                                     playsInline 
//                                                     ref={(video) => { if (video) video.play(); }}
//                                                 >
//                                                     <source src={vid1} type="video/mp4" />
//                                                     Your browser does not support the video tag.
//                                                 </video>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="join-team-container" style={{backgroundColor: '#F0F6FF'}}>
//                             <div className="images-containers">
//                                 <img
//                                     src={img1}
//                                     alt="Robotic Arm"
//                                     className="robotic-arm"
//                                 />
//                             </div>
//                             <div className="text-container" style={{marginLeft:'60px'}}>
//                                 <h1>
//                                     Innovation Solution For Your <span className="highlight-1">Welding </span> Needs.
//                                 </h1>
//                                 <p style={{ fontSize: '18px', textAlign: 'justify', color:'#666' }}>
//                                     If you're in search of cutting-edge robotic welding solutions, you've come to the right place. At HHG Industries, we specialize in delivering self-contained, plug-and-weld robotic welding cells that are ready to boost your production efficiency. Whether you're looking to hire or buy robotic welding cells, we've got you covered.
//                                 </p>
//                             </div>
//                         </div>
//                         <div className="elementor-element elementor-element-aceda80 e-flex e-con-boxed e-con e-parent" data-id="aceda80" data-element_type="container" data-settings='{"content_width":"boxed"}' data-core-v316-plus="true" style={{backgroundColor: '#ffffff'}}>
//                             <div className="e-con-inner">
//                                 <div className="elementor-element elementor-element-69de9a7 e-flex e-con-boxed e-con e-child" data-id="69de9a7" data-element_type="container" data-settings='{"background_background":"classic","content_width":"boxed"}' style={{backgroundColor: '#F0F6FF'}}>
//                                     <div className="e-con-inner">
//                                         <div className="elementor-element elementor-element-3fd95bf e-flex e-con-boxed e-con e-child" data-id="3fd95bf" data-element_type="container" data-settings='{"content_width":"boxed"}'>
//                                             <div className="e-con-inner">
//                                                 <div className="elementor-element elementor-element-4c24650 e-con-full e-flex e-con e-child" data-id="4c24650" data-element_type="container" data-settings='{"content_width":"full"}'>
//                                                     <div className="elementor-element elementor-element-e890865 elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="e890865" data-element_type="widget" data-widget_type="heading.default">
//                                                          <div className="text-container">
//                                                        <h1>
//                                     <span className="highlight-1">Pressing</span> and <span className="highlight-1">Riveting</span>
//                                 </h1>
//                                                     </div>
//                                                     </div>
//                                                     <div className="elementor-element elementor-element-5c004df elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="5c004df" data-element_type="widget" data-widget_type="text-editor.default">
//                                                         <div className="elementor-widget-container">
//                                                             <p style={{ fontSize: '18px', textAlign: 'justify', color:'#666' }}>A clinching press is used in manufacturing to join two or more pieces of sheet metal without additional fasteners.</p>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="elementor-element elementor-element-47da202 e-con-full e-flex e-con e-child" data-id="47da202" data-element_type="container" data-settings='{"background_background":"classic","content_width":"full"}'>
//                                                     <video 
//                                                         className="custom-video" 
//                                                         autoPlay 
//                                                         muted 
//                                                         loop 
//                                                         playsInline 
//                                                         ref={(video) => { if (video) video.play(); }}
//                                                     >
//                                                         <source src={vid3} type="video/mp4" />
//                                                         Your browser does not support the video tag.
//                                                     </video>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="join-team-container" style={{backgroundColor: '#F0F6FF'}}>
//                             <div className="images-containers">
//                                 <img
//                                     src={img3}
//                                     alt="Robotic Arm"
//                                     className="robotic-arm"
//                                 />
//                             </div>
//                             <div className="text-container">
//                                 <h1>
//                                     <span className="highlight-1">Robotic</span> Fixture
//                                 </h1>
//                                 <p style={{ fontSize: '18px', textAlign: 'justify', color:'#666' }}>
//                                     A robot-integrated solution enhances efficiency, Optimizing workflows with precision and consistency. Seamless automation reduces errors and delays, Driving productivity in modern industrial ways.
//                                 </p>
//                             </div>
//                         </div>
//                         <div className="elementor-element elementor-element-aceda80 e-flex e-con-boxed e-con e-parent" data-id="aceda80" data-element_type="container" data-settings='{"content_width":"boxed"}' data-core-v316-plus="true" style={{backgroundColor: '#ffffff'}}>
//                             <div className="e-con-inner">
//                                 <div className="elementor-element elementor-element-69de9a7 e-flex e-con-boxed e-con e-child" data-id="69de9a7" data-element_type="container" data-settings='{"background_background":"classic","content_width":"boxed"}' style={{backgroundColor: '#F0F6FF'}}>
//                                     <div className="e-con-inner">
//                                         <div className="elementor-element elementor-element-3fd95bf e-flex e-con-boxed e-con e-child" data-id="3fd95bf" data-element_type="container" data-settings='{"content_width":"boxed"}'>
//                                             <div className="e-con-inner">
//                                                 <div className="elementor-element elementor-element-4c24650 e-con-full e-flex e-con e-child" data-id="4c24650" data-element_type="container" data-settings='{"content_width":"full"}'>
//                                                     <div className="elementor-element elementor-element-e890865 elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="e890865" data-element_type="widget" data-widget_type="heading.default">
//                                                        <div className="text-container">
//                                                        <h1>
//                                     EQL <span className="highlight-1">Testing</span> and <span className="highlight-1">Marking</span>
//                                 </h1>
//                                                     </div>
//                                                     </div>
//                                                     <div className="elementor-element elementor-element-5c004df elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="5c004df" data-element_type="widget" data-widget_type="text-editor.default">
//                                                         <div className="elementor-widget-container">
//                                                             <p style={{ fontSize: '18px', textAlign: 'justify', color:'#666' }}>Measure and check the functionality of automotive electronic control units, mechanical parts and related systems</p>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="elementor-element elementor-element-47da202 e-con-full e-flex e-con e-child" data-id="47da202" data-element_type="container" data-settings='{"background_background":"classic","content_width":"full"}'>
//                                                     <video 
//                                                         className="custom-video" 
//                                                         autoPlay 
//                                                         muted 
//                                                         loop 
//                                                         playsInline 
//                                                         ref={(video) => { if (video) video.play(); }}
//                                                     >
//                                                         <source src={vid2} type="video/mp4" />
//                                                         Your browser does not support the video tag.
//                                                     </video>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="join-team-container" style={{backgroundColor: '#F0F6FF'}}>
//                             <div className="text-container">
//                                 <h1>
//                                     Smart  <span className="highlight-1">Inventory  </span> Management System
//                                 </h1>
//                                 <p style={{ fontSize: '18px', textAlign: 'justify', color:'#666' }}>
//                                     is an advanced robotic solution designed to automate the storage, tracking, and retrieval of inventory with precision. It enhances efficiency by minimizing human intervention, reducing errors, and optimizing space utilization. Equipped with sensors and automated conveyors, it ensures seamless inventory management in warehouses, manufacturing, and logistics.
//                                 </p>
//                             </div>
//                             <div className="images-containers">
//                                 <img
//                                     src={img2}
//                                     alt="Robotic Arm"
//                                     className="robotic-arm"
//                                 />
//                             </div>
//                         </div>
//                         <div className="elementor-element elementor-element-aceda80 e-flex e-con-boxed e-con e-parent" data-id="aceda80" data-element_type="container" data-settings='{"content_width":"boxed"}' data-core-v316-plus="true" style={{backgroundColor: '#ffffff'}}>
//                             <div className="e-con-inner">
//                                 <div className="elementor-element elementor-element-69de9a7 e-flex e-con-boxed e-con e-child" data-id="69de9a7" data-element_type="container" data-settings='{"background_background":"classic","content_width":"boxed"}' style={{backgroundColor: '#F0F6FF'}}>
//                                     <div className="e-con-inner">
//                                         <div className="elementor-element elementor-element-3fd95bf e-flex e-con-boxed e-con e-child" data-id="3fd95bf" data-element_type="container" data-settings='{"content_width":"boxed"}'>
//                                             <div className="e-con-inner">
//                                                 <div className="elementor-element elementor-element-47da202 e-con-full e-flex e-con e-child" data-id="47da202" data-element_type="container" data-settings='{"background_background":"classic","content_width":"full"}'>
//                                                     <video 
//                                                         className="custom-video" 
//                                                         autoPlay 
//                                                         muted 
//                                                         loop 
//                                                         playsInline 
//                                                         ref={(video) => { if (video) video.play(); }}
//                                                     >
//                                                         <source src={vid4} type="video/mp4" />
//                                                         Your browser does not support the video tag.
//                                                     </video>
//                                                 </div>
//                                                 <div className="elementor-element elementor-element-4c24650 e-con-full e-flex e-con e-child" data-id="4c24650" data-element_type="container" data-settings='{"content_width":"full"}'>
//                                                     <div className="elementor-element elementor-element-e890865 elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="e890865" data-element_type="widget" data-widget_type="heading.default">
//                                                         <div className="text-container">
//                                                        <h1>
//                                     <span className="highlight-1">Pick</span> and <span className="highlight-1">Place</span>
//                                 </h1>
//                                                     </div>
//                                                     </div>
//                                                     <div className="elementor-element elementor-element-5c004df elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="5c004df" data-element_type="widget" data-widget_type="text-editor.default">
//                                                         <div className="elementor-widget-container">
//                                                             <p style={{ fontSize: '18px', textAlign: 'justify', color:'#666' }}>These advanced robotic systems speed up the process of picking up parts or items and placing them in nearby locations. By automating this repetitive task, we enhance production rates while freeing up human workers to focus on more complex responsibilities.</p>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="join-team-container" style={{backgroundColor: '#F0F6FF'}}>
//                             <div className="text-container">
//                                 <h1>
//                                     Precision  <span className="highlight-1">Gauge </span>
//                                 </h1>
//                                 <p style={{ fontSize: '18px', textAlign: 'justify', color:'#666' }}>
//                                     is a specialized fixture used in industries to accurately inspect and verify the quality of components with complex shapes. It ensures precise measurements, consistency, and adherence to design specifications, minimizing defects in manufacturing. Commonly used in automotive, aerospace, and engineering industries, it enhances quality control and production efficiency.
//                                 </p>
//                             </div>
//                             <div className="images-containers">
//                                 <img
//                                     src={img4}
//                                     alt="Robotic Arm"
//                                     className="robotic-arm"
//                                 />
//                             </div>
//                         </div>
//                         <div className="elementor-element elementor-element-aceda80 e-flex e-con-boxed e-con e-parent" data-id="aceda80" data-element_type="container" data-settings='{"content_width":"boxed"}' data-core-v316-plus="true" style={{backgroundColor: '#ffffff'}}>
//                             <div className="e-con-inner">
//                                 <div className="elementor-element elementor-element-69de9a7 e-flex e-con-boxed e-con e-child" data-id="69de9a7" data-element_type="container" data-settings='{"background_background":"classic","content_width":"boxed"}' style={{backgroundColor: '#F0F6FF'}}>
//                                     <div className="e-con-inner">
//                                         <div className="elementor-element elementor-element-3fd95bf e-flex e-con-boxed e-con e-child" data-id="3fd95bf" data-element_type="container" data-settings='{"content_width":"boxed"}'>
//                                             <div className="e-con-inner">
//                                                 <div className="elementor-element elementor-element-47da202 e-con-full e-flex e-con e-child" data-id="47da202" data-element_type="container" data-settings='{"background_background":"classic","content_width":"full"}'>
//                                                     <video 
//                                                         className="custom-video" 
//                                                         autoPlay 
//                                                         muted 
//                                                         loop 
//                                                         playsInline 
//                                                         ref={(video) => { if (video) video.play(); }}
//                                                     >
//                                                         <source src={vid5} type="video/mp4" />
//                                                         Your browser does not support the video tag.
//                                                     </video>
//                                                 </div>
//                                                 <div className="elementor-element elementor-element-4c24650 e-con-full e-flex e-con e-child" data-id="4c24650" data-element_type="container" data-settings='{"content_width":"full"}'>
//                                                     <div className="elementor-element elementor-element-e890865 elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="e890865" data-element_type="widget" data-widget_type="heading.default">
//                                                         <div className="text-container">
//                                                        <h1>
//                                     <span className="highlight-1">Conveyor</span> Systems 
//                                 </h1>
//                                                     </div>
//                                                     </div>
//                                                     <div className="elementor-element elementor-element-5c004df elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="5c004df" data-element_type="widget" data-widget_type="text-editor.default">
//                                                         <div className="elementor-widget-container">
//                                                             <p style={{ fontSize: '18px', textAlign: 'justify', color:'#666' }}>HHG offers a range of conveyor solutions, from belt conveyors to roller conveyors, designed to optimize material handling, improve efficiency, and streamline production processes. Our conveyor systems are reliable, low-maintenance, and adaptable to various industries.</p>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>


// <style>{`
// /* iPad / Tablet fix */
// @media (min-width: 769px) and (max-width: 1024px) {
//   .e-con-inner.flex {
//     flex-direction: column !important;
//     align-items: center !important;
//     text-align: center;
//     padding: 20px;
//   }

//   .elementor-element-77a7fed {
//     width: 100% !important;
//     margin-left: 0 !important;
//     padding: 0 20px;
//   }

//   .animated-text {
//     margin-left: 0 !important;
//     font-size: 36px !important;
//   }

//   .elementor-element-74dcfa1 h5 {
//     font-size: 20px !important;
//   }

// .w-2\/6 {
//   width: 85% !important;
//   max-width: 500px;
//   margin-left: auto !important;
//   margin-right: auto !important;
//   margin-top: 20px;
// }
//   .join-team-container {
//     flex-direction: column !important;
//     padding: 20px !important;
//     align-items: center;
//   }

//   .text-container {
//     margin-left: 0 !important;
//     padding: 0 20px;
//     text-align: justify;
//   }

//   .robotic-arm {
//     width: 80% !important;
//     max-width: 350px;
//     height: auto;
//     margin-bottom: 20px;
//   }

//   .custom-video {
//     width: 100% !important;
//     height: auto !important;
//   }
// }
//       @media (max-width: 768px) {
//         .e-con-inner.flex {
//           flex-direction: column !important;
//           align-items: center !important;
//           text-align: center;
//         }

//         .elementor-element-77a7fed {
//           width: 100% !important;
//           margin-left: 0 !important;
//           padding: 0 15px;
//         }

//         .elementor-element-74dcfa1 h5,
//         .animated-text {
//           font-size: 24px !important;
//           margin: 10px 0 !important;
//         }

//         .animated-text {
//           margin-left: 0 !important;
//         }

//         .w-2/6 {
//           width: 80% !important;
//           margin-left: 0 !important;
//           margin-top: 20px;
//         }

//         .w-2/6 img {
//           width: 100% !important;
//           height: auto !important;
//         }

//         .join-team-container {
//           flex-direction: column !important;
//           padding: 20px !important;
//         }

//         .text-container {
//           margin-left: 0 !important;
//           padding: 0 15px;
//         }

//         .images-containers {
//           text-align: center;
//         }

//         .robotic-arm {
//           width: 100% !important;
//           max-width: 300px;
//           height: auto;
//           margin-bottom: 20px;
//         }

//         .custom-video {
//           width: 100% !important;
//           height: auto !important;
//         }

//         .elementor-widget-container p {
//           font-size: 16px !important;
//           text-align: justify !important;
//         }

//         .elementor-heading-title {
//           font-size: 22px !important;
//         }

//         .text-container h1 {
//           font-size: 24px !important;
//           line-height: 1.4;
//         }
//       }

//     `}</style>
//         </>

//     )
    
// }


// export default Products;

import { React } from 'react';
import vid1 from '../Assets/hhg_viedos/ft  wide 1.mp4';
import vid2 from '../Assets/hhg_viedos/hipl05.46.mp4';
import vid3 from '../Assets/hhg_viedos/hyd  wide 1.mp4';
import vid4 from '../Assets/hhg_viedos/pick and place  wide 1.mp4';
import vid5 from '../Assets/hhg_viedos/conveyor  wide 1.mp4';
import vid6 from '../Assets/hhg_viedos/pick wide 1.mp4';
import img1 from '../Assets/Images/Innovation.png';
import img3 from '../Assets/Images/Robotic.png';
import img2 from '../Assets/Images/Smart.png';
import img4 from '../Assets/img/case71.png';
import { ProductsComponent } from './ProductsComponent';
import heroImage from '../Assets/Images/image 3234.png';

const Products = () => {
    return (
        <>
            <div className='page-template page-template-elementor_header_footer page page-id-1458 jkit-color-scheme elementor-default elementor-template-full-width elementor-kit-3 elementor-page elementor-page-1458'>
                <div id="page" className="jkit-template site">
                    <div data-elementor-type="wp-page" data-elementor-id="1458" className="elementor elementor-1458">

                        {/* HERO SECTION */}
                        <div className="elementor-element elementor-element-0ad9abe e-flex e-con-boxed e-con e-parent hero-section" data-id="0ad9abe" data-element_type="container" data-settings='{"background_background":"gradient","content_width":"boxed"}' data-core-v316-plus="true">
                            <div className="e-con-inner flex flex-row items-center">
                                <div className="elementor-element elementor-element-77a7fed e-con-full e-flex e-con e-child" data-id="77a7fed" data-element_type="container" data-settings='{"content_width":"full"}'>
                                    <div className="elementor-element elementor-element-74dcfa1 elementor-widget__width-inherit elementor-invisible elementor-widget elementor-widget-heading" data-id="74dcfa1" data-element_type="widget" data-settings='{"_animation":"fadeInUp"}' data-widget_type="heading.default">
                                        <div className="elementor-widget-container">
                                            <h5 className="elementor-heading-title elementor-size-default text-left">Our Products</h5>
                                        </div>
                                    </div>
                                    <div className="elementor-element elementor-element-2b47805 elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-invisible elementor-widget elementor-widget-jkit_animated_text" data-id="2b47805" data-element_type="widget" data-settings='{"_animation_delay":200,"_animation":"fadeInUp"}' data-widget_type="jkit_animated_text.default">
                                        <div className="elementor-widget-container">
                                            <div className="jeg-elementor-kit jkit-animated-text jeg_module_1458_2_676b7a305aa37" data-style="highlighted" data-text="Touch " data-shape="underline">
                                                <h1 className="animated-text text-left">
                                                    <span className="normal-text style-color" style={{color:'#004E98'}}>Which System Is Right For You?</span>
                                                </h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="hero-img-wrapper">
                                    <img
                                        src={heroImage}
                                        alt="Hero Image"
                                        style={{width:'100%', height:'auto', display:'block'}}
                                    />
                                </div>
                            </div>
                        </div>

                        <ProductsComponent/>

                        {/* PRODUCT SECTIONS */}
                        <div className="products-wrapper">

                            {/* AutoTestIQ */}
                            <div className="product-card">
                                <div className="product-text">
                                    <h1>Auto<span className="highlight-1">TestIQ</span></h1>
                                    <p>Measure and check the functionality of automotive electronic control units, mechanical parts and related systems.</p>
                                </div>
                                <div className="product-media">
                                    <video className="custom-video" autoPlay muted loop playsInline ref={(video) => { if (video) video.play(); }}>
                                        <source src={vid1} type="video/mp4" />
                                    </video>
                                </div>
                            </div>

                            {/* Welding */}
                            <div className="join-team-card">
                                <div className="join-media">
                                    <img src={img1} alt="Innovation" className="join-img" />
                                </div>
                                <div className="join-text">
                                    <h1>Innovation Solution For Your <span className="highlight-1">Welding</span> Needs.</h1>
                                    <p>If you're in search of cutting-edge robotic welding solutions, you've come to the right place. At HHG Industries, we specialize in delivering self-contained, plug-and-weld robotic welding cells that are ready to boost your production efficiency. Whether you're looking to hire or buy robotic welding cells, we've got you covered.</p>
                                </div>
                            </div>

                            {/* Pressing and Riveting */}
                            <div className="product-card">
                                <div className="product-text">
                                    <h1><span className="highlight-1">Pressing</span> and <span className="highlight-1">Riveting</span></h1>
                                    <p>A clinching press is used in manufacturing to join two or more pieces of sheet metal without additional fasteners.</p>
                                </div>
                                <div className="product-media">
                                    <video className="custom-video" autoPlay muted loop playsInline ref={(video) => { if (video) video.play(); }}>
                                        <source src={vid3} type="video/mp4" />
                                    </video>
                                </div>
                            </div>

                            {/* Robotic Fixture */}
                            <div className="join-team-card">
                                <div className="join-media">
                                    <img src={img3} alt="Robotic" className="join-img" />
                                </div>
                                <div className="join-text">
                                    <h1><span className="highlight-1">Robotic</span> Fixture</h1>
                                    <p>A robot-integrated solution enhances efficiency, optimizing workflows with precision and consistency. Seamless automation reduces errors and delays, driving productivity in modern industrial ways.</p>
                                </div>
                            </div>

                            {/* EQL Testing */}
                            <div className="product-card">
                                <div className="product-text">
                                    <h1>EQL <span className="highlight-1">Testing</span> and <span className="highlight-1">Marking</span></h1>
                                    <p>Measure and check the functionality of automotive electronic control units, mechanical parts and related systems.</p>
                                </div>
                                <div className="product-media">
                                    <video className="custom-video" autoPlay muted loop playsInline ref={(video) => { if (video) video.play(); }}>
                                        <source src={vid2} type="video/mp4" />
                                    </video>
                                </div>
                            </div>

                            {/* Smart Inventory */}
                            <div className="join-team-card reverse">
                                <div className="join-text">
                                    <h1>Smart <span className="highlight-1">Inventory</span> Management System</h1>
                                    <p>is an advanced robotic solution designed to automate the storage, tracking, and retrieval of inventory with precision. It enhances efficiency by minimizing human intervention, reducing errors, and optimizing space utilization. Equipped with sensors and automated conveyors, it ensures seamless inventory management in warehouses, manufacturing, and logistics.</p>
                                </div>
                                <div className="join-media">
                                    <img src={img2} alt="Smart Inventory" className="join-img" />
                                </div>
                            </div>

                            {/* Pick and Place */}
                            <div className="product-card reverse">
                                <div className="product-media">
                                    <video className="custom-video" autoPlay muted loop playsInline ref={(video) => { if (video) video.play(); }}>
                                        <source src={vid4} type="video/mp4" />
                                    </video>
                                </div>
                                <div className="product-text">
                                    <h1><span className="highlight-1">Pick</span> and <span className="highlight-1">Place</span></h1>
                                    <p>These advanced robotic systems speed up the process of picking up parts or items and placing them in nearby locations. By automating this repetitive task, we enhance production rates while freeing up human workers to focus on more complex responsibilities.</p>
                                </div>
                            </div>

                            {/* Precision Gauge */}
                            <div className="join-team-card reverse">
                                <div className="join-text">
                                    <h1>Precision <span className="highlight-1">Gauge</span></h1>
                                    <p>is a specialized fixture used in industries to accurately inspect and verify the quality of components with complex shapes. It ensures precise measurements, consistency, and adherence to design specifications, minimizing defects in manufacturing. Commonly used in automotive, aerospace, and engineering industries, it enhances quality control and production efficiency.</p>
                                </div>
                                <div className="join-media">
                                    <img src={img4} alt="Precision Gauge" className="join-img" />
                                </div>
                            </div>

                            {/* Conveyor Systems */}
                            <div className="product-card reverse">
                                <div className="product-media">
                                    <video className="custom-video" autoPlay muted loop playsInline ref={(video) => { if (video) video.play(); }}>
                                        <source src={vid5} type="video/mp4" />
                                    </video>
                                </div>
                                <div className="product-text">
                                    <h1><span className="highlight-1">Conveyor</span> Systems</h1>
                                    <p>HHG offers a range of conveyor solutions, from belt conveyors to roller conveyors, designed to optimize material handling, improve efficiency, and streamline production processes. Our conveyor systems are reliable, low-maintenance, and adaptable to various industries.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <style>{`

              /* ============ HERO SECTION ============ */
              .hero-section {
                height: auto !important;
                min-height: unset !important;
                padding: 0 !important;
                overflow: hidden;
              }

              .hero-section .e-con-inner.flex {
                max-width: 1300px !important;
                margin: 0 auto !important;
                padding: 40px 20px 0 20px !important;
                display: flex !important;
                flex-direction: row !important;
                justify-content: space-between !important;
                align-items: flex-end !important;
                width: 100% !important;
                box-sizing: border-box !important;
              }

              .hero-section .elementor-element-77a7fed {
                width: 50% !important;
                margin-left: 0 !important;
                flex-shrink: 0;
                align-self: center !important;
              }

              .hero-section .elementor-heading-title {
                font-size: 20px;
                text-align: left !important;
              }

              .hero-section .animated-text.text-left {
                text-align: left !important;
                margin-left: 0 !important;
                font-size: 42px;
              }

              .hero-section .hero-img-wrapper {
                display: block !important;
                width: 45% !important;
                margin-left: 0 !important;
                align-self: flex-end !important;
                margin-bottom: 0 !important;
                visibility: visible !important;
                opacity: 1 !important;
                flex-shrink: 0;
              }

              .hero-section .hero-img-wrapper img {
                width: 100% !important;
                height: auto !important;
                display: block !important;
              }

              /* ============ PRODUCTS WRAPPER ============ */
              .products-wrapper {
                background: #ffffff;
                padding: 20px;
                display: flex;
                flex-direction: column;
                gap: 30px;
                max-width: 1300px;
                margin: 0 auto;
                box-sizing: border-box;
              }

              /* ============ PRODUCT CARD (text + video) ============ */
              .product-card {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 30px;
                background: #F0F6FF;
                border-radius: 16px;
                padding: 30px;
                box-sizing: border-box;
              }

              .product-card.reverse {
                flex-direction: row-reverse;
              }

              .product-text {
                flex: 1;
                min-width: 0;
              }

              .product-text h1 {
                font-size: 28px;
                margin-bottom: 12px;
                line-height: 1.3;
              }

              .product-text p {
                font-size: 16px;
                color: #666;
                text-align: justify;
                line-height: 1.7;
              }

              .product-media {
                flex: 1;
                min-width: 0;
              }

              .custom-video {
                width: 100% !important;
                height: auto !important;
                border-radius: 10px;
                display: block;
              }

              /* ============ JOIN TEAM CARD (text + image) ============ */
              .join-team-card {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 30px;
                background: #F0F6FF;
                border-radius: 16px;
                padding: 30px;
                box-sizing: border-box;
              }

              .join-team-card.reverse {
                flex-direction: row-reverse;
              }

              .join-text {
                flex: 1;
                min-width: 0;
              }

              .join-text h1 {
                font-size: 28px;
                margin-bottom: 12px;
                line-height: 1.3;
              }

              .join-text p {
                font-size: 16px;
                color: #666;
                text-align: justify;
                line-height: 1.7;
              }

              .join-media {
                flex: 1;
                min-width: 0;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .join-img {
                width: 100%;
                max-width: 380px;
                height: auto;
                display: block;
                border-radius: 8px;
              }

              .highlight-1 {
                color: #004E98;
              }

              /* ============ TABLET (769px - 1024px) ============ */
              @media (min-width: 769px) and (max-width: 1024px) {
                .hero-section .e-con-inner.flex {
                  padding: 30px 20px 0 20px !important;
                  gap: 20px !important;
                }

                .hero-section .elementor-element-77a7fed {
                  width: 50% !important;
                }

                .hero-section .animated-text.text-left {
                  font-size: 28px !important;
                }

                .hero-section .elementor-heading-title {
                  font-size: 16px !important;
                }

                .hero-section .hero-img-wrapper {
                  width: 45% !important;
                }

                .product-card,
                .product-card.reverse,
                .join-team-card,
                .join-team-card.reverse {
                  flex-direction: column !important;
                  padding: 20px !important;
                }

                .product-text h1,
                .join-text h1 {
                  font-size: 24px !important;
                }

                .join-img {
                  max-width: 300px !important;
                }
              }

              /* ============ MOBILE (max 768px) ============ */
              @media (max-width: 768px) {
                /* Hero */
                .hero-section .e-con-inner.flex {
                  flex-direction: column !important;
                  align-items: flex-start !important;
                  padding: 24px 20px 0 20px !important;
                  gap: 0 !important;
                }

                .hero-section .elementor-element-77a7fed {
                  width: 100% !important;
                }

                .hero-section .animated-text.text-left {
                  font-size: 26px !important;
                }

                .hero-section .elementor-heading-title {
                  font-size: 14px !important;
                }

                .hero-section .hero-img-wrapper {
                  width: 100% !important;
                  align-self: center !important;
                  margin-top: 10px !important;
                }

                /* Cards */
                .products-wrapper {
                  padding: 15px !important;
                  gap: 20px !important;
                }

                .product-card,
                .product-card.reverse,
                .join-team-card,
                .join-team-card.reverse {
                  flex-direction: column !important;
                  padding: 16px !important;
                  gap: 16px !important;
                }

                .product-text h1,
                .join-text h1 {
                  font-size: 22px !important;
                }

                .product-text p,
                .join-text p {
                  font-size: 15px !important;
                }

                .join-img {
                  max-width: 100% !important;
                }
              }

            `}</style>
        </>
    );
};

export default Products;